import React from 'react';
import { useTranslation } from 'react-i18next';
import { displaySectionTime } from 'containers/inProgressPage/helpers/displaySectionTime';
import {
  SectionLandingTopContainer,
  SectionLandingTopWrapper,
  SectionLandingHeader,
  SectionLandingInfo,
  SectionLandingDivider
} from 'containers/inProgressPage/styles/StyledComponents';

const SectionLandingTop = ({ currentSection, isStock }) => {
  const { t } = useTranslation();
  const { section } = currentSection;
  return (
    <>
      <SectionLandingTopContainer>
        <SectionLandingTopWrapper>
          <SectionLandingHeader
            fontWeight={isStock ? 'bold' : null}
            color={isStock ? '#85807c' : null}
          >
            {t('sectionPage.section')}
          </SectionLandingHeader>
          <SectionLandingInfo>
            {section.title || `Section ${currentSection.sort_index + 1}`}
          </SectionLandingInfo>
        </SectionLandingTopWrapper>
        <SectionLandingTopWrapper>
          <SectionLandingHeader
            fontWeight={isStock ? 'bold' : null}
            color={isStock ? '#85807c' : null}
          >
            {t('sectionPage.duration')}
          </SectionLandingHeader>
          <SectionLandingInfo>{displaySectionTime(section)}</SectionLandingInfo>
        </SectionLandingTopWrapper>
        {!isStock && (
          <SectionLandingTopWrapper>
            <SectionLandingHeader>
              {t('sectionPage.numberOfQuestions')}
            </SectionLandingHeader>
            <SectionLandingInfo>
              {section.standard_question_list.length}
            </SectionLandingInfo>
          </SectionLandingTopWrapper>
        )}
      </SectionLandingTopContainer>
      <SectionLandingDivider />
    </>
  );
};

export default SectionLandingTop;
